module.exports = __webpack_public_path__ + "assets/evaluation-a252a0cc.svg";